<template lang="pug">
  include ./../../mixins
  +b.pagination(
    v-if='page && page.info.total > 0'
  )
    +e.element--offset_full
      +b.ug-row--apearance_spaced.--space_md
        +b.ug-cell.ug-cols--12.--narrow-lg(
          style="display: flex"
        )
          +b.pagination__action
            +b.ug-row--apearance_spaced.--space_md.--align_center
              +b.ug-cell.ug-cols--12.--auto-md
                +b.ug-row--apearance_spaced.--space_md.--align_center
                  +b.ug-cell.ug-cols--12.--narrow-sm Lines per page:
                  +b.ug-cell.ug-cols--12.--auto-sm
                    +b.DIV.D-CONTROL-OPTION(
                      v-model="limit"
                      :object-list="options"
                      :placeholder="'Limit'"
                      :name="'status'"
                      id="status"
                      @change="updateLimitHandler"
                    )
              +b.ug-cell.ug-cols--12.--narrow-sm Showing {{ pageObj.from }} to {{ page.count < pageObj.to ? page.count : pageObj.to }} of {{ page.count }} objects
        +b.ug-cell.ug-cols--12.--auto-lg
          +b.pagination__list.UL
            +e.prev.icon--type_prev.LI(
              :class='{"is-disabled": !page.hasPrevious()}'
              @click.prevent='previous()'
            )
            template(
              v-if='page.hasPrevious()'
            )
              +e.item.LI(
                @click.prevent='select(range.min)'
              ) {{ range.min }}
            +e.item--inactive.LI(
              v-if='gaps.left'
            ) &hellip;
            +e.item.LI(
              v-for='page in fills.left'
              @click.prevent='select(page)'
            ) {{ page }}
            +e.item--active.LI(
              v-text='page.getPageNumber()'
            )
            +e.item.LI(
              v-for='page in fills.right'
              @click.prevent='select(page)'
            ) {{ page }}
            +e.item--inactive.LI(
              v-if='gaps.right'
            ) &hellip;
            template(
              v-if='page.hasNext()'
            )
              +e.item.LI(
                @click.prevent='select(range.max)'
              ) {{ range.max }}
            +e.next.icon--type_next.LI(
              :class='{"is-disabled": !page.hasNext()}'
              @click.prevent='next()'
            )
</template>

<script>
import {
  LimitOffsetPagination
} from '@/js/scripts/pagination'

export default {
  name: 'PaginationModule',
  props: {
    pagination: {},
    needAddBtns: {
      type: Boolean,
      default: () => {
        return false
      }
    },
    extra: {
      type: Number,
      default: 2
    },
    reset: {},
  },
  created() {
    if (this.page) this.recalcRange()
  },
  data() {
    return {
      options: [
        {
          label: '10',
          id: 10,
        },
        {
          label: '50',
          id: 50,
        },
        {
          label: '100',
          id: 100,
        },
      ],
      limit: 10,
      range: {
        min: 0,
        max: Infinity
      },
      gaps: {
        left: false,
        right: false
      },
      fills: {
        left: [],
        right: []
      },
      page: {},
      zero: 0,
      one: 1,
      show: true
    }
  },
  computed: {
    pageObj() {
      let to = this.page.limit + this.page.offset
      let from = this.page.offset + this.one

      return { to: to, from: from }
    }
  },
  watch: {
    pagination: {
      deep: true,
      immediate: true,
      handler() {
        this.page = new LimitOffsetPagination(this.pagination)
        this.show = true
      }
    },
    page(nval, oval) {
      this.recalcRange()
    },
    reset(nval, oval) {
      if (nval) {
        this.show = true
      }
    }
  },
  methods: {
    updateLimitHandler(value) {
      this.$emit('update-limit', value)
    },
    showAll(e) {
      this.$emit('showAll', e)
    },
    recalcRange() {
      let current = this.page.getPageNumber()
      let [min, max] = this.page.getPageRange()
      let [start, end] = this.page.getPageRange(this.extra, current)
      let range = Array
        .apply(null, { length: end - start + this.one })
        .map((x, i) => i + start)
      let currentIndex = range.indexOf(current)

      if (currentIndex !== -this.one) {
        this.fills.left = range.slice(this.zero, currentIndex)
        let minIndex = this.fills.left.indexOf(min)
        if (minIndex >= this.zero) {
          this.fills.left.splice(minIndex, this.one)
        }
        this.fills.right = range.slice(currentIndex + this.one)
        let maxIndex = this.fills.right.indexOf(max)
        if (maxIndex >= this.zero) {
          this.fills.right.splice(maxIndex, this.one)
        }
      } else {
        this.fills.left = this.fills.right = []
      }

      this.gaps.left = (
        this.fills.left.length &&
        this.fills.left[0] !== min + this.one
      )

      this.gaps.right = (
        this.fills.right.length &&
        this.fills.right[this.fills.right.length-this.one] !== max - this.one
      )

      this.range.min = min
      this.range.max = max
    },

    select(number) {
      this.$emit('input', this.page.getParameters(number))
    },

    next() {
      this.$emit('input', this.page.next())
    },

    previous() {
      this.$emit('input', this.page.previous())
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/js/components/Modules/PaginationModule.vue